class AdaptiveSelect extends HTMLElement {
    constructor() {
      super();
      this.mainSelect = this.querySelector(".select-adaptive")
      this.widthSelect = this.querySelector("#width_tmp_select");
      this.optionWidth = this.querySelector("#width_tmp_option");
    }
  
    connectedCallback() {
      this.startWidth();
      this.bindEvents();
    }
  
    setSelectWidth() {
      this.optionWidth.innerHTML = this.mainSelect.options[this.mainSelect.selectedIndex].innerText.trim();
      this.mainSelect.style.width = this.widthSelect.offsetWidth + 18 + "px";
    }
  
    startWidth() {
      this.setSelectWidth();
      this.mainSelect.style.display = "block";
    }
  
    bindEvents() {
      this.mainSelect.addEventListener("change", () => {
        this.setSelectWidth();
      })
    }
}

customElements.define('adaptive-select', AdaptiveSelect);